import React from "react";
import "../progress-container/styles.css";
import PaymentIcon from "../../icons/payment-icon";
import Text from "../typography/text";
import { formatNumber } from "../card";
import { colors } from "../../theme/colors";
import FailureIcon from "../../icons/failure-icon";

const ProgressContainer = ({
  invoiceTotal,
  shippingCost,
  processingFees = [],
  sentToCollectionTotal,
  sentToCollectionBreakdown = [],
  totalPaymentsApplied,
  openBalance,
  pastDue,
  fullyPaid,
  progressBarWidth,
  openBalanceDays,
  pastDueDays,
  actionComponent,
}) => {
  const [whole, decimal] = formatNumber(invoiceTotal).split(".");
  const [whole2, decimal2] = formatNumber(totalPaymentsApplied).split(".");
  const [whole3, decimal3] = formatNumber(openBalance).split(".");
  const [whole4, decimal4] = formatNumber(pastDue).split(".");
  const [whole5, decimal5] = formatNumber(
    sentToCollectionTotal ?? 0,
  ).split(".");
  const formattedShippingCost = formatNumber(shippingCost);
  const hasShippingCost = Number(shippingCost) > 0;
  const hasSentToCollectionTotal =
    sentToCollectionTotal !== null && sentToCollectionTotal !== undefined;
  const includedCosts = [
    hasShippingCost ? `Shipping Cost of $${formattedShippingCost}` : null,
    ...processingFees
      .filter((fee) => Number(fee?.amount) > 0 && fee?.label)
      .map((fee) => `${fee.label} of $${formatNumber(fee.amount)}`),
  ].filter(Boolean);
  const sentToCollectionCosts = sentToCollectionBreakdown
    .filter((cost) => Number(cost?.amount) > 0 && cost?.label)
    .map((cost) => `${cost.label} of $${formatNumber(cost.amount)}`);

  return (
    <div className="progress-container">
      <div className="progress-container-numbers">
        <div className="progress-container-section">
          <div className="details-title-container">
            <PaymentIcon className="icon-container" />
            <Text variant="tinyText" color="lightText">
              Invoice Total
            </Text>
          </div>
          <Text variant="numberBig">
            ${whole}
            <Text variant="numbersSmall" color="strokeDark">
              .{decimal}
            </Text>
          </Text>
          {includedCosts.length > 0 && !hasSentToCollectionTotal ? (
            <Text variant="tinyText" color="lightText">
              Includes {includedCosts.join(" and ")}
            </Text>
          ) : null}
        </div>
        {hasSentToCollectionTotal ? (
          <div className="progress-container-section">
            <div className="details-title-container">
              <PaymentIcon className="icon-container" />
              <Text variant="tinyText" color="lightText">
                Sent To Collections
              </Text>
            </div>
            <Text variant="numberBig">
              ${whole5}
              <Text variant="numbersSmall" color="strokeDark">
                .{decimal5}
              </Text>
            </Text>
            {sentToCollectionCosts.length > 0 ? (
              <Text variant="tinyText" color="lightText">
                Includes {sentToCollectionCosts.join(" and ")}
              </Text>
            ) : null}
          </div>
        ) : null}
        <div className="progress-container-section">
          <div className="details-title-container">
            <PaymentIcon className="icon-container" />
            <Text variant="tinyText" color="lightText">
              Total Payments Applied
            </Text>
          </div>
          <Text variant="numberBig">
            ${whole2}
            <Text variant="numbersSmall" color="strokeDark">
              .{decimal2}
            </Text>
          </Text>
        </div>
        {/* {openBalance ? (
          <div className="progress-container-section">
            <div className="details-title-container">
              <PaymentIcon className="icon-container" />
              <Text variant="tinyText" color="lightText">
                Open Balance
              </Text>
            </div>
            <Text variant="numberBig">
              ${whole3}
              <Text variant="numbersSmall" color="strokeDark">
                .{decimal3}
              </Text>
            </Text>
          </div>
        ) : null} */}
        {pastDue ? (
          <div className="progress-container-section">
            <div className="details-title-container">
              <FailureIcon className="icon-container-failure" />
              <Text variant="tinyText" color="failureColor">
                Past Due
              </Text>
            </div>
            <Text variant="numberBig" color="failureColor">
              ${whole4}
              <Text variant="numbersSmall" color="failureColor">
                .{decimal4}
              </Text>
            </Text>
          </div>
        ) : (
          <div className="progress-container-section">
            <div className="details-title-container">
              <PaymentIcon className="icon-container" />
              <Text variant="tinyText" color="lightText">
                Open Balance
              </Text>
            </div>
            {openBalance ? (
              <Text variant="numberBig">
                ${whole3}
                <Text variant="numbersSmall" color="strokeDark">
                  .{decimal3}
                </Text>
              </Text>
            ) : (
              <Text variant="numberBig">$0</Text>
            )}
          </div>
        )}
      </div>
      {/* Progress Bar */}
      <div className="progress-bar-container">
        <div
          className="progress-bar-width"
          style={{
            width: `${progressBarWidth}%`,
            backgroundColor: pastDue
              ? colors["failureColor"]
              : colors["successColor"],
          }}
        ></div>
      </div>
      {/* Balance Due */}
      <div className="progress-container-footer">
        {pastDue ? (
          <Text variant="tinyText" color="lightText">
            Balance was due {pastDueDays} days ago
          </Text>
        ) : openBalance ? (
          <Text variant="tinyText" color="lightText">
            Balance due in {openBalanceDays} days
          </Text>
        ) : (
          <Text variant="tinyText" color="lightText">
            Invoice was fully paid on {fullyPaid}
          </Text>
        )}
        {actionComponent}
      </div>
      {/* {fullyPaid ? (
        <Text variant="tinyText" color="lightText">
          Invoice was fully paid on {fullyPaid}
        </Text>
      ) : null} */}
    </div>
  );
};

export default ProgressContainer;
